<template>
<footer class="text-black body-font font-mono text-micro flex justify-center px-5 md:pt-10">
    <div class="flex flex-wrap text-center">
        <nav class="list-none flex justify-center my-4 grid grid-cols-3 md:grid-cols-6 md:flex md:flex-row">
            <li class="p-2">
                <a class="hover:text-gray-600">
                    <router-link to="/shop/"> view all </router-link>
                </a>
            </li>
            <li class="p-2">
                <a class="hover:text-gray-600">
                    <router-link to="/shop/sizing"> sizing </router-link>
                </a>
            </li>
            <li class="p-2">
                <a class="hover:text-gray-600">
                    <router-link to="/shop/shipping"> shipping </router-link>
                </a>
            </li>
            <li class="p-2">
                <a class="hover:text-gray-600">
                    <router-link to="/shop/terms"> terms </router-link>
                </a>
            </li>
            <li class="p-2">
                <a class="hover:text-gray-600">
                    <router-link to="/shop/privacy"> privacy </router-link>
                </a>
            </li>
            <li class="p-2">
                <a class="hover:text-gray-600">
                    <router-link to="/shop/faq"> f.a.q. </router-link>
                </a>
            </li>
        </nav>
    </div>
</footer>
</template>

<script>
export default {
    name: 'ShopFooter',
    components: {},
    data() {
        return {}
    }
}
</script>

<style>
.text-micro {
    font-size: 0.65rem;
    line-height: 0.9rem;
}
</style>
